
import Avislist from "../components/AvisListe";


export default function AvisPage() {

  return (
    <div className=" w-[100%] h-[100%]  flex flex-col items-center justify-center  absolute mt-[10%] p-9">

     <Avislist />
    </div>
  );
}
